<template>
  <div>
    <v-navigation-drawer 
      :fixed="true" :dark="$theme.menu.darkMode" 
      :class="$theme.menu.bodyClass"
      class="menu-drawer"
      :clipped="clipped" v-model="drawer" enable-resize-watcher app>
      <menu-side-bar></menu-side-bar>
    </v-navigation-drawer>

    <v-toolbar fixed app :clipped-left="clipped"  class="elevation-1">
      <v-toolbar-side-icon v-if="!drawer" @click.stop="drawer = !drawer"></v-toolbar-side-icon>

      <v-toolbar-title id="toolbarTitle" v-text="translateTitle"></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <v-btn :to="{name: 'profile'}" icon slot="activator">
          <v-icon color="black">account_box</v-icon>
        </v-btn>
        <span>Perfil</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn @click="logout()" icon slot="activator">
          <v-icon color="black">power_settings_new</v-icon>
        </v-btn>
        <span>Sair</span>
      </v-tooltip>
    </v-toolbar>
  </div>
</template>

<script>
  import MenuSideBar from './MenuSideBar';

  export default {
    name: 'header-nav',
    components: {
      MenuSideBar,
    },
    data() {
      return {
        title: this.$router.currentRoute.name,
        clipped: false,
        drawer: this.$vuetify.breakpoint.smAndUp,
      };
    },
    watch: {
      /**
       * Metodo responsavel por atribuir o titulo atraves da route.
       */
      $route(to) {
        this.title = to.name;
      },
    },
    computed: {
      /**
       * Método responsavel por traduzir o title.
       */
      translateTitle() {
        return this.$t(`views.breadcrumbs.${this.title}`);
      },
    },
    methods: {
      /**
       * Metodo responsavel por efetuar o logout da aplicacao.
       * Dispara um evento para limpar o cache.
       */
      logout() {
        this.$store.dispatch('logout');
        this.$toast.success('Deslogado com sucesso');
        this.$router.replace('/');
      },
    },
  };

</script>
<style>
@media print{
  .v-content {
    padding: 0 !important;
  }
  .menu-drawer {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/HeaderNav.vue